import { RouteConfig } from 'vue-router'
import { IUserProfileService } from './IUserProfileService'
import { getChildSections } from '@core/pages/userProfile/route'

export class DefaultUserProfileService implements IUserProfileService {
  retrieveChildSections (systemRole: string, router): RouteConfig {
    return getChildSections(systemRole, router) as any
  }
}
